var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedConfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.088,
    height: 135.599,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SpeedConfIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 286",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SpeedConfIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 287",
    fill: "none",
    d: "M0 0h80v80H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SpeedConfIcon_svg__a)",
    transform: "translate(18.995 42.533)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 313",
    fill: "#040000",
    clipPath: "url(#SpeedConfIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 329",
    d: "M40.029 8.608a19.789 19.789 0 00-20 19.57c0 7.052 3.154 14.21 9.112 17.188h21.78c5.958-2.978 9.112-10.136 9.112-17.188a19.786 19.786 0 00-20-19.57m0 31.794a12.609 12.609 0 1112.6-12.608 12.609 12.609 0 01-12.6 12.608m0-23.8A11.188 11.188 0 1051.215 27.79a11.188 11.188 0 00-11.186-11.188"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 330",
    d: "M61.344 65.015l11.85-18.1L56.98 35.939l2.859-4.8 19.112 13.223a2.434 2.434 0 01.617 3.386l-.026.037-16.1 19.954-11.548 3.625a.608.608 0 01-.466-1.118z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 331",
    d: "M18.656 65.015l-11.85-18.1L23.02 35.939l-2.859-4.8L1.05 44.362a2.434 2.434 0 00-.617 3.386l.026.037 16.1 19.954L28.1 71.363a.608.608 0 00.466-1.118z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "2Arrows"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 3",
    d: "M49.41 13.712l-4.124 4.125 29.491 29.49 4.125-4.124 5.706 19.034-19.035-5.706 4.042-4.042L40.125 23l-4.042 4.042L30.373 8z",
    fill: "#3086ff",
    stroke: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow.image"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2",
    d: "M27.525 25.602v5.681h62.038v-5.681l26.022 9.18-26.022 9.178v-5.566H27.525v5.566L1.503 34.78z",
    fill: "#ff3e3e",
    stroke: "#4d4d4d"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow.image"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 2",
    d: "M70.743 95.248h-7.27v27.93h7.27l-11.748 11.715-11.746-11.715h7.123v-27.93h-7.123l11.748-11.715z",
    fill: "#00b050",
    stroke: "#4d4d4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedConfIcon);
export default __webpack_public_path__ + "static/media/SpeedConfIcon.31132f369c3570db.svg";
export { ForwardRef as ReactComponent };